// トップページ: ピックアップスライダー初期化 (Swiper v8)
// - ページに.pickup-swiperが存在する場合に動作（フロントページ）
// - 存在しない場合は安全にスキップ（何もしない）
// - 複数インスタンスに対応
// - SP時のみ有効（max-width: 768px）
// - リサイズイベントを処理して動的に有効化/無効化
(function () {
  var SP_BREAKPOINT = 768;
  var swiperInstances = [];
  var resizeTimer = null;

  function isSP() {
    return window.innerWidth <= SP_BREAKPOINT;
  }

  function findInstance(el) {
    for (var i = 0; i < swiperInstances.length; i++) {
      if (swiperInstances[i].element === el) {
        return i;
      }
    }
    return -1;
  }

  function destroyAll() {
    for (var i = 0; i < swiperInstances.length; i++) {
      var instance = swiperInstances[i];
      if (instance.swiper && instance.swiper.destroy) {
        instance.swiper.destroy(true, true);
      }
    }
    swiperInstances = [];
  }

  function initAll() {
    if (typeof window.Swiper === "undefined") return;
    if (!isSP()) return;

    var containers = document.querySelectorAll(".pickup-swiper");
    if (!containers.length) return;

    containers.forEach(function (el) {
      // 既に初期化済みの場合はスキップ
      if (findInstance(el) !== -1) return;

      var paginationEl = el.querySelector(".swiper-pagination");
      // ガード: マークアップが存在しない場合、ページネーション要素を作成
      if (!paginationEl) {
        paginationEl = document.createElement("div");
        paginationEl.className = "swiper-pagination";
        el.appendChild(paginationEl);
      }

      // eslint-disable-next-line no-new
      var swiper = new Swiper(el, {
        loop: true,
        speed: 1500,
        watchOverflow: true, // スライドが足りない場合は無効化
        centeredSlides: true,
        spaceBetween: 16,
        slidesPerView: 1,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        // アクセシビリティのベースライン
        a11y: {
          enabled: true,
        },
      });

      swiperInstances.push({
        element: el,
        swiper: swiper,
      });
    });
  }

  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var currentlySP = isSP();
      var hasInstances = swiperInstances.length > 0;

      if (currentlySP && !hasInstances) {
        // SPに切り替え: 初期化
        initAll();
      } else if (!currentlySP && hasInstances) {
        // PCに切り替え: 破棄
        destroyAll();
      }
    }, 100);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var containers = document.querySelectorAll(".pickup-swiper");
    if (!containers.length) return;

    // SwiperはWPのenqueue経由でロードされ、グローバルに利用可能
    if (typeof window.Swiper === "undefined") {
      // 防御的: 何らかの理由でSwiperが準備できていない場合、load後に1回再試行
      window.addEventListener(
        "load",
        function () {
          if (isSP()) {
            initAll();
          }
          window.addEventListener("resize", handleResize);
        },
        { once: true }
      );
      return;
    }

    // 初期セットアップ
    if (isSP()) {
      initAll();
    }

    // リサイズイベントを処理
    window.addEventListener("resize", handleResize);
  });
})();
